// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"SkewedTooltipComplex_tooltip_2wYjO","tooltipTitleWrapper":"SkewedTooltipComplex_tooltipTitleWrapper_CH7Pi","tooltipContent":"SkewedTooltipComplex_tooltipContent_1LYu1"};